module.exports = __webpack_public_path__ + "img/windows_default.5d66553f.png";